import React from 'react';
import {Platform, ScrollView, View} from 'react-native';

import Button from '/component/base/Button';
import Icon from '/component/base/Icon';
import BasePopover from '/component/base/Popover';
import TouchableOpacity from '/component/base/TouchableOpacity';
import Gutter from '/component/layout/Gutter';
import {withSafeArea} from '/provider/SafeAreaProvider';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {getPopoverContent, getStyles} from '../CoachReportPopover.util';
import {Loading as CoachInfoLoading} from '../component/CoachInfo';
import {Loading as VolumeLoading} from '../component/Volume';

import {ALL_CONTENT} from './Loading.constant';
import {styles} from './Loading.style';

// Define the types for the component props
interface LoadingProps {
  tt: (key: string, fallback: string) => string;
  ts: (key: string, fallback: string) => string;
  safeAreaInsets: object;
  contentName: string;
  popoverClose: () => void;
  contentProps: object;
}

const Loading = ({
  tt,
  ts,
  safeAreaInsets = {},
  contentName = '',
  popoverClose,
  contentProps = {},
}: LoadingProps) => {
  const isWeb = Platform.OS === 'web';
  const {popoverStyle, footerButtonStyle} = getStyles(safeAreaInsets);
  const PopoverContent = getPopoverContent(contentName, ALL_CONTENT);

  return (
    <BasePopover style={popoverStyle} padded={false}>
      <View style={styles.closeButton}>
        <TouchableOpacity
          accessible={true}
          accessibilityRole="button"
          accessibilityLabel={ts('close', 'Close')}
          onPress={popoverClose}>
          <Icon name="close" />
        </TouchableOpacity>
      </View>
      <Gutter>
        <CoachInfoLoading />
      </Gutter>
      <ScrollView>
        <PopoverContent {...contentProps} />
        <Gutter>
          <VolumeLoading />
        </Gutter>
      </ScrollView>
      <View style={footerButtonStyle}>
        <Gutter>
          <Button
            disabled
            accessibilityLabel="View profile"
            style={
              isWeb
                ? {
                    base: {
                      minHeight: 28,
                      paddingHorizontal: 14,
                      paddingVertical: 6,
                    },
                    text: {fontSize: 13},
                  }
                : undefined
            }>
            {tt('footer.profileButton.label', 'View Profile')}
          </Button>
        </Gutter>
      </View>
    </BasePopover>
  );
};

// Wrap the component with HOC functions
export default withHOC(
  withSafeArea,
  withTranslation('reportCard.coach'),
)(Loading);
